import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL + "/admin/daily-sentences",
 headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
 const token = getToken();
 if (token) {
 config.headers.Authorization = `Bearer ${token}`;
 } else {
 }
 return config;
});

// ===== CATEGORIES =====
export const fetchCategories = async (params = {}) => {
 try {
 const cleaned = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null));
 const res = await api.get("/categories", { params: cleaned });
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch categories" };
 }
};

export const createCategory = async (data) => {
 try {
 const res = await api.post("/categories", data);
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Create failed" };
 }
};

export const updateCategory = async (id, data) => {
 try {
 const res = await api.put(`/categories/${id}`, data);
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Update failed" };
 }
};

export const deleteCategory = async (id) => {
 try {
 const res = await api.delete(`/categories/${id}`);
 return { status: res.status };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.error || err.response?.data?.message || "Delete failed" };
 }
};

export const fetchCategoryById = async (id) => {
 try {
 const res = await api.get(`/categories/${id}`);
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" };
 }
};

// ===== OPTIONS =====
export const fetchSentenceOptions = async () => {
 try {
 const res = await api.get("/options");
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch options" };
 }
};

// ===== SENTENCES =====
export const fetchDailySentences = async (params) => {
 try {
 const res = await api.get("", { params });
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" };
 }
};

export const fetchDailySentenceById = async (id) => {
 try {
 const res = await api.get(`/${id}`);
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" };
 }
};

export const createDailySentence = async (data) => {
 try {
 const res = await api.post("", data);
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Create failed" };
 }
};

export const updateDailySentence = async (id, data) => {
 try {
 const res = await api.put(`/${id}`, data);
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Update failed" };
 }
};

export const deleteDailySentence = async (id) => {
 try {
 const res = await api.delete(`/${id}`);
 return { status: res.status };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Delete failed" };
 }
};
